<div class="bewerking-pill">
  <ng-content></ng-content>
  <div class="description">
    {{bewerking.description}}
  </div>
  <div class="close remove-button" aria-label="Close" (click)="removePill()">
    <span aria-hidden="true">&times;</span>
  </div>
</div>

